import { action } from 'typesafe-actions'

import { Brand } from './brands'

export enum brandsActionType {
  FETCH_BRANDS = 'FETCH_BRANDS',
  FETCH_BRANDS_SUCCEEDED = 'FETCH_BRANDS_SUCCEEDED',
  THROW_ERROR = 'THROW_ERROR',
}

export const brandsActions = {
  fetchBrands: () => action(brandsActionType.FETCH_BRANDS),
  fetchBrandsSucceeded: (brands: Brand[]) =>
    action(brandsActionType.FETCH_BRANDS_SUCCEEDED, { brands }),
  throwError: (error: Error) =>
    action(brandsActionType.THROW_ERROR, { error }),
}
